import React from "react"
import ReactDOM from "react-dom/client"
import "./ressource/css/custom-styles.css"
import "./ressource/css/main.css"
import "./ressource/css/custoPreview.css"
import App from "./App"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
